import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[bidDisableControl]',
})
export class DisableControlDirective {
  @Input() set bidDisableControl(condition: string) {
    let booleanValue = false;
    if (condition === 'false') {
      booleanValue = false;
    } else {
      booleanValue = true;
    }
    const action = booleanValue ? 'disable' : 'enable';
    this.ngControl.control[action]();
    if (action === 'disable') {
      this.ngControl.control.setValue('');
    }
  }

  // eslint-disable-next-line
  constructor(private ngControl: NgControl) {}
}
